import axiosInstance from "./axios-instance";
import { cloneCacheValue, isMutationSuccess } from "./cache-utils";
// import axios from "axios";

const createCustomer = async (accountId: number) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/create-customer",
            { accountId },
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createCheckout = async (accountId: number, expired: boolean) => {
    // const getRestBaseEndpoint = () => {
    //     //getDeployOptions() doesnt seem to be working
    //     const options = (window as any).__DEPLOY_OPTIONS;
    //     return options.restApiUrl;
    // };

    // const axiosInstance = axios.create({
    //     baseURL: getRestBaseEndpoint(),
    // });
    // try {
    //     const response = await axiosInstance.get("/stripe/createPaymentIntent");

    //     return response.data;
    // } catch (error) {
    //     console.log("Error fetching payment intent", error);
    // }
    try {
        const response = await axiosInstance.post(
            "/stripe/create-checkout-session",
            { accountId, expired },
        );
        if (isMutationSuccess(response.data)) {
            invalidatePlanInfoCache(accountId);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Dedupe layer for /stripe/get-plan-info. Multiple components fetch the same
// plan info on page load. Same pattern as account.getAccount — in-flight
// sharing + short result cache. Plan info changes very rarely so a slightly
// longer TTL is fine.
const PLAN_INFO_TTL_MS = 10000;
const inFlightPlanInfo = new Map<number, Promise<any>>();
const resultPlanInfo = new Map<number, { data: any; fetchedAt: number }>();

const getCustomerPlanInfo = async (accountId: number) => {
    const cached = resultPlanInfo.get(accountId);
    if (cached && Date.now() - cached.fetchedAt < PLAN_INFO_TTL_MS) {
        return cloneCacheValue(cached.data);
    }
    const inFlight = inFlightPlanInfo.get(accountId);
    if (inFlight) {
        return cloneCacheValue(await inFlight);
    }
    const promise = (async () => {
        try {
            const response = await axiosInstance.post("/stripe/get-plan-info", {
                accountId,
            });
            resultPlanInfo.set(accountId, { data: cloneCacheValue(response.data), fetchedAt: Date.now() });
            return response.data;
        } catch (error) {
            console.log(error);
            return { error };
        } finally {
            inFlightPlanInfo.delete(accountId);
        }
    })();
    inFlightPlanInfo.set(accountId, promise);
    return cloneCacheValue(await promise);
};

const invalidatePlanInfoCache = (accountId?: number): void => {
    if (accountId === undefined) {
        inFlightPlanInfo.clear();
        resultPlanInfo.clear();
        return;
    }

    inFlightPlanInfo.delete(accountId);
    resultPlanInfo.delete(accountId);
};

const checkIsBilling = async (accountId: number) => {
    try {
        const response = await axiosInstance.post("/stripe/check-is-billing", {
            accountId,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getCustomerBillingHistory = async (accountId: number) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/get-billing-history",
            {
                accountId,
            },
        );
        return response.data;
    } catch (error) {
        console.log(error)
        return { error }
    }
};

const cancelSubscription = async (accountId: number) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/cancel-subscription",
            {
                accountId,
            },
        );
        if (isMutationSuccess(response.data)) {
            invalidatePlanInfoCache(accountId);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getPromoCode = async (code: string) => {
    // const getRestBaseEndpoint = () => {
    //     //getDeployOptions() doesnt seem to be working
    //     const options = (window as any).__DEPLOY_OPTIONS;
    //     return options.restApiUrl;
    // };

    // const axiosInstance = axios.create({
    //     baseURL: getRestBaseEndpoint(),
    // });
    try {
        const response = await axiosInstance.get(
            `/stripe/getPromoCode?code=${code}`,
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

const getLastDigits = async (accountId: number) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/get-last-4",
            {
                accountId,
            },
        );
        return response.data;
    } catch (error) {
        console.log(error)
        return { error }
    }
};

const updateStripeProfile = async (accountId: number, billingInfo: any) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/update-stripe-profile",
            {
                accountId,
                billingInfo
            },
        );
        if (isMutationSuccess(response.data)) {
            invalidatePlanInfoCache(accountId);
        }
        return response.data;
    } catch (error) {
        console.log(error)
    }
};

const updateStripePayment = async (accountId: number, token: string) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/update-stripe-payment",
            {
                accountId,
                token
            },
        );
        if (isMutationSuccess(response.data)) {
            invalidatePlanInfoCache(accountId);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createCustomerSession = async (customerId: string) => {
    try {
        const response = await axiosInstance.post(
            "/stripe/create-customer-session",
            {
                customerId,
            },
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export {
    createCheckout,
    createCustomer,
    getPromoCode,
    getCustomerPlanInfo,
    invalidatePlanInfoCache,
    getCustomerBillingHistory,
    cancelSubscription,
    getLastDigits,
    updateStripeProfile,
    checkIsBilling,
    updateStripePayment,
    createCustomerSession
};
